import { createContext } from 'react';

export interface CommunityMessageDataType {
  unreadCount: number | undefined;
  // Backend-authoritative per-channel DM unread counts, keyed by bare GetStream channel id.
  unreadOverridesByChannelId: Record<string, number>;
}

export interface CommunityDataContextType {
  messages: CommunityMessageDataType;
  markChatRead: (getstreamChannelId: string, lastMessageAt?: string) => void;
}

export const CommunityDataContext = createContext<CommunityDataContextType | null>(null);
